import { attachMountScenarioToWindow } from '@busyrooms/vue-commons/entries/attach_global'
import type { PredefinedClientConfiguration, PlayitasScenarioParams, IStaticConfiguration } from './types'

declare global {
  interface BusyRoomsGlobal {
    /** Legacy scenario name, okay for this template */
    mountIBE?: (params: PlayitasScenarioParams) => void
  }
}

/**
 * The Federated entrypoint for the IBE.
 * It will attach the `mountScenario` function to `window.BusyRooms` when in browser context,
 * and will also return it.
 * @param staticConfiguration Precompiled template configuration to apply (comes from Federated Host).
 *    This has the same schema for all templates and provides api keys, etc.
 * @param predefinedClientConfig Precompiled client configuration (also from Federated Host).
 *    This is for template-specific configurations, can be rewritten from outside.
 */
export default async function attachToGlobalAndReturn (
  staticConfiguration: IStaticConfiguration,
  predefinedClientConfig: PredefinedClientConfiguration
) {
  const templateMountScenario = (await import('./default.bootstrap')).default

  // Function which can combines baked configuration with dynamic one
  function mountScenario (params: PlayitasScenarioParams) {
    return templateMountScenario(staticConfiguration, {
      ...predefinedClientConfig,
      ...params
    })
  }

  // For this template only, a consumer expects `mountIBE` function (legacy reasons)
  if (typeof window !== 'undefined') {
    if (!window.BusyRooms) window.BusyRooms = {}
    window.BusyRooms.mountIBE = async (params: PlayitasScenarioParams) => {
      return mountScenario({
        ...params,
        scenario: 'single_property' as const
      })
    }
  }

  // Standard attachment to `window`
  attachMountScenarioToWindow(mountScenario)

  // Return function as well (ease of consumption)
  return mountScenario
}
